// src/components/SessionManager.jsx
import React, { useEffect, useRef, useContext, useState } from "react";
import { message } from "antd";
import AuthContext from "../context/authContext";
import SessionWarningModal from "../Modals/SessionWarningModal";
import SessionExpiredModal from "../Modals/SessionExpiredModal";

const SessionManager = () => {
  const { currentUser, logout } = useContext(AuthContext);

  // session state
  const [sessionExpired, setSessionExpired] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  // store timers in refs so they persist
  const warningTimerRef = useRef(null);
  const logoutTimerRef = useRef(null);

  // durations
  const WARNING_DELAY_MS = 89 * 60 * 1000; // 89 minutes
  const LOGOUT_DELAY_MS = 90 * 60 * 1000; // 90 minutes
        //For quick local testing you can temporarily override:
       //  const WARNING_DELAY_MS = 5 * 1000; // 5s
       //  const LOGOUT_DELAY_MS = 10 * 1000; // 10s

  // helper to clear timers
  const clearSessionTimers = () => {
    if (warningTimerRef.current) {
      clearTimeout(warningTimerRef.current);
      warningTimerRef.current = null;
    }
    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
      logoutTimerRef.current = null;
    }
  };

  // helper to start timers
  const startSessionTimers = () => {
    clearSessionTimers();

    warningTimerRef.current = setTimeout(() => {
      setShowWarning(true);
    }, WARNING_DELAY_MS);

    logoutTimerRef.current = setTimeout(() => {
      setShowWarning(false);
      setSessionExpired(true);
    }, LOGOUT_DELAY_MS);
  };

  // called when user presses "Verlängern"
  const handleExtendSession = () => {
    // try {
    //     // OPTIONAL: If  backend supports a session/token refresh endpoint,
    //     // call  to extend server-side session too:
    //     // await axios.post('/api/auth/refresh');
    //     // If the backend call fails, you can decide whether to still restart client timers.
    //   } catch (e) {
    //     console.error("Session refresh failed:", e);
    //     // optionally show message or fall back to restarting client-only timers
    //   }
    startSessionTimers();
    setShowWarning(false);
    message.success("Sitzung verlängert!");
  };

  // called when user chooses logout from warning
  const handleForceLogoutFromWarning = () => {
    clearSessionTimers();
    setShowWarning(false);
    setSessionExpired(true);
  };

  // watch currentUser and start/clear timers
  useEffect(() => {
    if (currentUser) {
      startSessionTimers();
    } else {
      clearSessionTimers();
    }

    return () => {
      clearSessionTimers();
    };
  }, [currentUser]);

  return (
    <>
      {/* Session Warning Modal */}
      <SessionWarningModal
        open={showWarning}
        onExtend={handleExtendSession}
        onLogout={handleForceLogoutFromWarning}
      />

      {/* Session Expired Modal */}
      <SessionExpiredModal
        open={sessionExpired}
        onConfirm={async () => {
            clearSessionTimers();
            await logout();
            setSessionExpired(false);
          }}
      />
    </>
  );
};

export default SessionManager;
